<template>
    <div class="page-content">
        <div class="page-content__wrapper">
            <div class="page-content__content">
                <supply-tenders-filter></supply-tenders-filter>

                <div class="table-card">
                    <supply-tenders-table
                        :table-data="getTendersList"
                    />
                    <div class="pagination" v-if="getTendersPagination.total > getTendersPagination.limit">
                        <vue-awesome-paginate
                            :total-items="getTendersPagination.total"
                            :items-per-page="getTendersPagination.limit"
                            :max-pages-shown="3"
                            v-model="curPage"
                        />
                    </div> 
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import SupplyTendersFilter from "@/components/sections/LcSupply/SupplyTenders/SupplyTendersFilter.vue";
import SupplyTendersTable from "@/components/sections/LcSupply/SupplyTenders/SupplyTendersTable.vue";
import {mapActions, mapGetters} from "vuex";

export default {
    name: "SupplyTendersPage",
    components: {SupplyTendersFilter, SupplyTendersTable},
    data() {
        return {
        }
    },
    async created() {
        await this.requestTendersList();
        await this.requestFavoritesTenders();
    },
    computed: {
        curPage: {
            get() {
                return Math.round(this.getTendersPagination.offset / this.getTendersPagination.limit) + 1
            },
            set(value) {
                this.updatePagination({offset: (value - 1) * this.getTendersPagination.limit})
            }
        },
        ...mapGetters({
            getTendersList: 'tenders/getTendersList',
            getFavoritesTenders: 'tenders/getFavoriteTenders',
            getTendersPagination: 'tenders/getTendersPagination',
        })
    },
    methods: {
        ...mapActions({
            requestTendersList: 'tenders/requestTendersList',
            requestFavoritesTenders: 'tenders/requestFavoritesTenders',
            updateFilterKey: 'tenders/updateFilterKey',
            updatePagination: 'tenders/updatePagination',
        })
    }
}
</script>

